<template>
<Navbar />
<Home />
<br>
<div>
    <Image1 />
</div>
<br>
<C />
<br>
<Fqa />
<Form />
<Whatsapp />
<Footer />
</template>

<script>
import Home from './components/Home.vue'
import Footer from './components/Footer.vue'
import Navbar from './components/Navbar.vue'
import Fqa from './components/Fqa.vue'
import Whatsapp from './components/Whatsapp.vue'
import Form from './components/Form.vue'
import C from './components/C.vue'
import Image1 from './components/Image1.vue'

export default {
    name: 'App',
    components: {
        Home,
        Footer,
        Navbar,
        Fqa,
        Whatsapp,
        Form,
        C,
        Image1
    }
}
</script>

<style>
body {
    overflow-x: hidden;
    margin: 0;
    padding: 0;
}
</style>
